import { useEffect, useState } from "react";
import { catalogApi, normalizeDepartment } from "../services/catalogs/systemCatalog.service";

export default function usePersonnelOrganization(active) {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [reload, setReload] = useState(0);

  useEffect(() => {
    if (!active) return;
    let current = true;
    setLoading(true);
    setError("");
    catalogApi.list("/Department").then((items) => {
      if (current) setDepartments(items.map(normalizeDepartment));
    }).catch(() => {
      if (current) setError("Không thể tải bộ lọc chi nhánh và phòng ban.");
    }).finally(() => { if (current) setLoading(false); });
    return () => { current = false; };
  }, [active, reload]);

  return { departments, loading, error, onRetry: () => setReload((count) => count + 1) };
}
